import { render, staticRenderFns } from "./NowOne.vue?vue&type=template&id=dd016962&scoped=true"
import script from "./NowOne.vue?vue&type=script&lang=js"
export * from "./NowOne.vue?vue&type=script&lang=js"
import style0 from "./NowOne.vue?vue&type=style&index=0&id=dd016962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd016962",
  null
  
)

export default component.exports